import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { getSiteIconBySiteType } from '../../utils';
import { listItem, searchListItemIcon, searchListItemIconDisabled } from './style';
import { MISSING_SITE_COORDINATES } from '../../config';
import { useResponsive } from 'src/hooks/useResponsive';
import { WarningIcon } from 'src/assets/icons/WarningIcon';
import { NewSite, Location } from 'src/types/sites/sites';

const getDisabled = (location: Location) => {
  if (location?.latitude && location?.longitude) {
    const latitudeNum = parseFloat(location.latitude);
    const longitudeNum = parseFloat(location.longitude);
    return !!(!latitudeNum || !longitudeNum);
  }
  return true;
};

type IconProps = {
  height?: number;
  width?: number;
  fill?: string;
};

export const SearchListItem = ({ item }: { item: NewSite }) => {
  const Icon: React.FunctionComponent<IconProps> | undefined = getSiteIconBySiteType(
    item.siteType.toLocaleLowerCase()
  );
  const isDisabled = getDisabled(item.location);
  const theme = useTheme();
  const isMobile = useResponsive('down', 600);

  return (
    <ListItem key={item.id} disablePadding>
      <ListItemButton disabled={isDisabled} role={undefined} dense>
        <ListItemIcon sx={searchListItemIcon}>
          {Icon && <Icon height={20} width={20} fill="#049ACC" />}
        </ListItemIcon>
        <ListItemText sx={listItem} id={item.id} primary={item.siteName} />
        {isDisabled && (
          <>
            <ListItemIcon sx={searchListItemIconDisabled}>
              <WarningIcon fill={theme.palette.warning.main} />
            </ListItemIcon>
            {!isMobile ? (
              <Typography color={theme.palette.warning.darker} variant="caption">
                {MISSING_SITE_COORDINATES}
              </Typography>
            ) : null}
          </>
        )}
      </ListItemButton>
    </ListItem>
  );
};
